export const LOCALES = { de: 'de-DE', en: 'en-GB' };

// Ersetzt {name}-Platzhalter; unbekannte Platzhalter bleiben unverändert.
export function interpolate(text, params) {
  if (!params) return text;
  return text.replace(/\{(\w+)\}/g, (match, key) =>
    Object.prototype.hasOwnProperty.call(params, key) ? String(params[key]) : match
  );
}

export function localeFor(lang) {
  return LOCALES[lang] || LOCALES.de;
}

export function formatDate(value, lang, options) {
  return new Date(value).toLocaleDateString(localeFor(lang), options);
}

export function formatNumber(value, lang, options) {
  return new Intl.NumberFormat(localeFor(lang), options).format(value);
}
